import { getDestinationImage } from 'lib/search/destinationImageMap'

export function isExperienceSearchItem(item: App.SearchItem): boolean {
  if (item.searchType === 'experience') return true
  return item.searchType === 'searchItemV3' && item.display.searchType === 'experience'
}

export function getSearchItemExperienceId(item: App.SearchItem): string | undefined {
  if (item.searchType === 'experience') return item.value

  if (item.searchType === 'searchItemV3' && item.display.searchType === 'experience') {
    if (item.display.offerId) return item.display.offerId
    const { extractedData } = item.searchItem
    if (extractedData.searchType === 'experience') return extractedData.offerId
  }

  return undefined
}

export function getSearchItemDestinationId(item: App.SearchItem): string | undefined {
  if (isExperienceSearchItem(item)) return undefined

  if (item.searchType === 'destination' || item.searchType === 'landmark') {
    return item.value
  }

  if (item.searchType === 'searchItemV3') {
    const { extractedData } = item.searchItem
    if (extractedData.searchType === 'experience') return undefined
    if ('placeIds' in extractedData) return extractedData.placeIds?.[0]
  }

  return undefined
}

export function getSearchItemDisplayName(item: App.SearchItem): string {
  return item.format.mainText
}

export function getSearchItemImageId(item: App.SearchItem): string | undefined {
  const typeaheadImageId = item.searchType === 'searchItemV3'
    ? item.display.imageId ?? item.format.imageId
    : item.format.imageId ?? item.imageId

  if (typeaheadImageId) return typeaheadImageId

  const destinationId = getSearchItemDestinationId(item)
  if (!destinationId) return undefined

  return getDestinationImage(destinationId) || undefined
}
